import React, {useEffect, useRef, useState} from "react";

import Slider from "react-slick";
import TeamMember from "./TeamMember";
import styled from "styled-components";

const TeamSection = ({team}) => {
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef();

  const [settings, setSettings] = useState({
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    swipeToSlide: true,
    variableWidth: false,
    afterChange: (index) => setCurrentSlide(index)
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSettings({
        infinite: true,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        swipeToSlide: true,
        variableWidth: false,
        afterChange: (index) => setCurrentSlide(index)
      });
    }
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) return;

    const elements = document.getElementsByClassName("team-member-slide");
    for (let i = 0; i < elements.length; i++) {
      elements[i].parentNode.style.marginLeft = "1rem";
      elements[i].parentNode.style.marginRight = "1rem";
    }
  }, [isMobile]);


  const handleDiamondClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
      setCurrentSlide(index);
    }
  };

  if (isMobile) {
    return (
      <MobileContainer>
        <Slider ref={sliderRef} {...settings}>
          {team.map((member, index) => (
            <SlideWrapper key={index} className="team-member-slide">
              <TeamMember
                {...member}
                showBullets
                bulletCount={4}
                bulletIndex={index < 2 ? index
                  : index > team.length - 3 ? 4 - (team.length - index)
                    : 2}
                dotWindowStart={index < 2 ? 0
                  : index > team.length - 3 ? team.length - 4
                    : index - 2}
                teamLength={team.length}
                mobileIdx={index}
              />
            </SlideWrapper>
          ))}
        </Slider>

        <DotsContainer>
          {team.map((_, index) => (
            <DiamondDot
              key={index}
              active={index === currentSlide}
              onClick={() => handleDiamondClick(index)}
            />
          ))}
        </DotsContainer>
      </MobileContainer>
    );
  }

  return (
    <TeamGrid>
      {team.map((member, idx) => (
        <TeamMember
          key={idx}
          {...member}
          showBullets={false}
          bulletCount={4}
          bulletIndex={0}
          dotWindowStart={0}
          teamLength={team.length}
          mobileIdx={0}
        />
      ))}
    </TeamGrid>
  );
};

const MobileContainer = styled.div`
  width: 100%;
  margin-bottom: 2.66rem;
  position: relative;
  min-height: 36rem;

  .slick-dots {
    display: none !important;
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    border-bottom: 2px dashed #E4E4E4;
    bottom: -4rem;
  }
`;

const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const DiamondDot = styled.div`
  width: 1rem;
  height: 1rem;
  background: ${props => props.active ? "#6725F4" : "#bdbdbd"};
  transform: rotate(45deg);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: ${props => props.active ? "#6725F4" : "#999"};
    transform: rotate(45deg) scale(1.2);
  }

  &:active {
    transform: rotate(45deg) scale(0.95);
  }
`;

const SlideWrapper = styled.div`
  padding: 0 10px;
  display: flex !important;
  justify-content: center;
  align-items: center;
`;

const TeamGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px 5px;
  justify-items: center;
  margin: 0 auto 0 auto;
  position: relative;
  min-height: 52rem;

  > *:nth-child(10) {
    grid-column: 2;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default TeamSection;
